import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { Button, message, Input, Card, Form, Select, InputNumber, Col, Row, Table, Typography } from 'antd';
import { getLabelFromMap, createJsonOptions } from '@/scripts/utils';
import { SEARCH_ITEM_COL, SEARCH_ITEM_GUTTER } from '@/scripts/config';
// import useSearchList from '@/hooks/useSearchList';
import dayjs from 'dayjs';

const pageKey = 'CheckAccountList'; //页面身份
export default function CheckAccountList() {
    const [dataSource, setData] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const [count, setCount] = useState(2);
    const [form] = Form.useForm();
    const [formSearch] = Form.useForm();

    const loading = () => {
        ajax.get('account/list?type=check_auth')
            .then((response) => {
                // 添加禁用状态 默认false
                const data = response.map((item) => {
                    item.update_time = item.update_time ? dayjs(item.update_time).format('YYYY-MM-DD HH:mm:ss') : null;
                    if (item.is_refresh == 1) {
                        item.is_refresh = '是';
                    } else if (item.is_refresh == 0) {
                        item.is_refresh = '否';
                    }
                    return item;
                });

                setData(data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        loading();
    }, []);

    const edit = (record) => {
        form.setFieldsValue({
            id: record.id,
            username: record.username,
            password: record.password,
            is_refresh: record.is_refresh,
            ...record,
        });
        setEditingKey(record.id);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            // align: 'center',
            width: 80,
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: '账号',
            dataIndex: 'username',
            // align: 'center',
            width: 200,
            editable: true,
            sorter: (a, b) => a['username'].localeCompare(b['username']),
        },
        {
            title: '密码',
            dataIndex: 'password',
            // align: 'center',
            editable: true,
            width: 200,
            sorter: (a, b) => a['password'].localeCompare(b['password']),
        },
        {
            title: '更新时间',
            dataIndex: 'update_time',
            // align: 'center',
            width: 200,
            sorter: (a, b) => +new Date(a.update_time) - +new Date(b.update_time),
        },
        {
            title: '是否刷新',
            dataIndex: 'is_refresh',
            // align: 'center',
            width: 200,
            editable: true,
            sorter: (a, b) => a['is_refresh'].localeCompare(b['is_refresh']),
        },
        {
            title: '操作',
            width: 80,
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => save(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            保存
                        </Typography.Link>
                        {/* <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                            <a href="#">Cancel</a>
                        </Popconfirm> */}
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        修改
                    </Typography.Link>
                );
            },
        },
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                refreshSelect: col.dataIndex === 'is_refresh' ? 'select' : 'text',
                editing: isEditing(record),
            }),
        };
    });

    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputTypeBox,
        inputType,
        inputTypeSelect,
        timeTypeSelect,
        refreshSelect,
        record,
        index,
        children,
        ...restProps
    }) => {
        let inputNode;
        if (inputType === 'number') {
            inputNode = <InputNumber />;
        } else {
            inputNode = <Input />;
        }
        if (refreshSelect === 'select') {
            inputNode = <Select style={{ width: 100 }} options={createJsonOptions(['是', '否'])} showSearch allowClear></Select>;
        }
        return (
            <td>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    const isEditing = (record) => record.id === editingKey;

    // 新增一行
    const handleAdd = (record) => {
        const newData = {
            add: 0,
            id: dataSource.length + 1,
            username: '',
            password: '',
            // update_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        };
        form.setFieldsValue(newData);
        setEditingKey(dataSource.length + 1);
        setData([newData, ...dataSource]);
        setCount(dataSource.length + 1);
    };

    // 保存
    const save = async (id) => {
        try {
            const row = await form.validateFields();
            const newData = [...dataSource];
            const index = newData.findIndex((item) => id === item.id);
            let params = {
                ...row,
                id: newData[index].id,
            };
            if (newData[index].add == 0) {
                // 添加
                if (params.username === '' || params.password === '') {
                    message.error('账号密码不能为空');
                    return;
                }
                if (params.is_refresh === '否') {
                    params.is_refresh = 0;
                } else if (params.is_refresh === '是') {
                    params.is_refresh = 1;
                }
                ajax.post('/account/insert', params)
                    .then((response) => {
                        setEditingKey('');
                        loading();
                    })

                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                // 修改
                if (params.username === '' || params.password === '') {
                    message.error('账号密码不能为空');
                    return;
                }
                if (params.is_refresh === '否') {
                    params.is_refresh = 0;
                } else if (params.is_refresh === '是') {
                    params.is_refresh = 1;
                }
                ajax.post('/account/list', params)
                    .then((response) => {
                        setEditingKey('');
                        loading();
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    return (
        <div className="list">
            <PageHeader title="检查账号列表" sticky></PageHeader>
            {/* <Card className="ax-table-card">{renderTable()}</Card> */}
            <Card style={{ width: '100%' }} className="ax-search-card">
                <Form form={formSearch} autoComplete="off">
                    <Row gutter={SEARCH_ITEM_GUTTER}>
                        <Col>
                            <Button
                                onClick={handleAdd}
                                type="primary"
                                style={{
                                    marginBottom: 16,
                                }}
                            >
                                新增一行
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    rowKey={(record) => record.name}
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    rowClassName="editable-row"
                    columns={mergedColumns}
                />
            </Form>
        </div>
    );
}
